require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/script-loader/addScript.js")(require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/raw-loader/index.js!/Users/admin/Projects/material-dashboard-angular-master/node_modules/bootstrap-notify/bootstrap-notify.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap-notify/bootstrap-notify.js
// module id = 263
// module chunks = 2